import { render, staticRenderFns } from "./ChatContact.vue?vue&type=template&id=1cd3c8ab&scoped=true"
import script from "./ChatContact.vue?vue&type=script&lang=js"
export * from "./ChatContact.vue?vue&type=script&lang=js"
import style0 from "./ChatContact.vue?vue&type=style&index=0&id=1cd3c8ab&prod&lang=scss"
import style1 from "./ChatContact.vue?vue&type=style&index=1&id=1cd3c8ab&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cd3c8ab",
  null
  
)

export default component.exports